export default {
    de: {
        components: {
            Branding: {
                collection: "Sammlung"
            },
            Navigation: {
                search: {
                    searchQuery: "----",
                    searchTitle: "Titel/Objektname",
                    searchYearFrom: "Jahr von (JJJJ)",
                    searchYearTo: "Jahr bis (JJJJ)",
                    searchPerson: "Designer/Hersteller",
                    searchMaterial: "Material/Technik",
                    searchInventoryNr: "Inventarnummer",
                    search: "Suchen"
                },
                extendedSearch: "Erweiterte Suche",
                ObjObjectTitleTxt: "Titel/Objektname",
                objects: 'Objekte',
                designers: 'Designer',
                producers: 'Hersteller',
                objCategories: 'Objekttyp',
                objAttributes: 'Eigenschaften',
                objUsage: 'Themen',
                objMaterials: 'Materialien',
                objHighlights: 'Highlights',
                objForKids: 'Für Kinder',
                myCollection: "Meine Sammlung",
                information: "Informationen",
            },
            SearchResults: {
                title: "Suchergebnisse",
                objects: "Objekte",
                designers: "Designer",
                producers: "Hersteller"
            },
            Objects: {
                title: 'Objekte'
            },
            ObjectDetail: {
                objectAttributes: 'Objektangaben',
                objectObjectRelations: 'Objekte',
                objectPersonRelation: 'Designer',
                ObjObjectNumberTxt: 'Objektnummer',
                ObjObjectTitleTxt: 'Titel/Objektname',
                ObjObjectTitleSubTxt: '',
                ObjDesigner: 'Designer',
                ObjCategoryVoc: 'Objekttyp',
                ObjDateGrp_DateFromTxt: 'Entwurfsdatum',
                ObjDateGrp_Notes2Clb: 'Erste Produktion',
                ObjDateGrp_Notes3Clb: 'Folgeproduktionen',
                ObjDateTxt: 'Produktionsdatum',
                ObjMaterialTechniqueTxt: 'Material/Technik',
                ObjDimension: 'Maße',
                ObjObjectNumberGrp_Part1Txt: 'Inventarnummer',
                ObjObjectRel: 'Objekte',
                ObjPersonRel: 'Designer',
                ObjRelDesigners: 'Designer',
                ObjRelProducers: 'Hersteller',
                ObjFloorplan: 'Objektstandort',
            },
            ContentList: {
                Typ: "Objekttyp",
                Funktion: "Eigenschaften",
                Verwendung: "Themen",
                Material: "Materialien",
            },
            Designers: {
                title: 'Designer'
            },
            Producers: {
                title: 'Hersteller'
            },
            PersonDetail: {
                PerObjectsRel: 'Objekte'
            },
            NoRecordsFound: {
                text: 'Keine Ergebnisse gefunden.'
            },
            BackLink: {
                text: 'Zurück'
            },
            MyCollection: {
                title: 'Meine Sammlung',
                buttonEdit: 'Bearbeiten',
                buttonDeleteAll: 'Alle löschen',
                objects: "Objekte",
                designers: "Designer",
                producers: "Hersteller",
            },
            Services: {
                share: 'Teilen',
            },
            SocialShare: {
                facebook: {
                    title: 'Facebook'
                },
                twitter: {
                    title: 'Twitter'
                },
                email: {
                    title: 'E-Mail',
                    subject: '',
                    text: ''
                },
            },
        }
    },
    fr: {
        components: {
            Branding: {
                collection: "Sammlung FR"
            },
            Navigation: {
                search: {
                    searchQuery: "----",
                    searchTitle: "Titel/Objektname FR",
                    searchYearFrom: "Jahr von (JJJJ) FR",
                    searchYearTo: "Jahr bis (JJJJ) FR",
                    searchPerson: "Designer/Hersteller FR",
                    searchMaterial: "Material/Technik FR",
                    searchInventoryNr: "Inventarnummer FR",
                    search: "Suchen FR"
                },
                extendedSearch: "Erweiterte Suche FR",
                ObjObjectTitleTxt: "Titel / Objektname FR",
                objects: 'Objekte FR',
                designers: 'Designer FR',
                producers: 'Hersteller FR',
                objCategories: 'Objekttyp FR',
                objAttributes: 'Eigenschaften FR',
                objMaterials: 'Materialien FR',
                objUsage: 'Themen FR',
                objHighlights: 'Highlights FR',
                objForKids: 'Für Kinder FR',
                myCollection: "Meine Sammlung FR",
                information: "Informationen FR",

            },
            SearchResults: {
                title: "Suchergebnisse FR",
                objects: "Objekte FR",
                designers: "Designer FR",
                producers: "Hersteller FR",
            },
            Objects: {
                title: 'Objects FR'
            },
            ObjectDetail: {
                objectAttributes: 'Objekteigenschaften FR',
                objectObjectRelations: 'Objekte FR',
                objectPersonRelation: 'Designer FR',
                ObjObjectNumberTxt: 'Objektnummer FR',
                ObjObjectTitleTxt: 'Titel/Objektname FR',
                ObjObjectTitleSubTxt: '',
                ObjDesigner: 'Designer FR',
                ObjCategoryVoc: 'Objekttyp FR',
                ObjDateGrp_DateFromTxt: 'Entwurfsdatum FR',
                ObjDateGrp_Notes2Clb: 'Erste Produktion FR',
                ObjDateGrp_Notes3Clb: 'Folgeproduktionen FR',
                ObjDateTxt: 'Produktionsdatum FR',
                ObjMaterialTechniqueTxt: 'Material/Technik FR',
                ObjDimension: 'Masse FR',
                ObjObjectNumberGrp_Part1Txt: 'Inventarnummer FR',
                ObjObjectRel: 'Objekte FR',
                ObjPersonRel: 'Designer FR',
                ObjRelDesigners: 'Designer FR',
                ObjRelProducers: 'Hersteller FR',
                ObjFloorplan: 'Objektstandort FR',
            },
            ContentList: {
                Typ: "Objekttyp FR",
                Funktion: "Eigenschaften FR",
                Verwendung: "Verwendung FR",
                Material: "Materialien FR",
            },
            Designers: {
                title: 'Designer FR'
            },
            Producers: {
                title: 'Hersteller FR'
            },
            PersonDetail: {
                PerObjectsRel: 'Objekte FR'
            },
            NoRecordsFound: {
                text: 'Keine Ergebnisse gefunden FR.'
            },
            BackLink: {
                text: 'Zurück FR'
            },
            MyCollection: {
                title: 'Meine Sammlung FR',
                buttonEdit: 'Bearbeiten FR',
                buttonDeleteAll: 'Alle löschen FR',
                objects: "Objekte FR",
                designers: "Designer FR",
                producers: "Hersteller FR",
            },
            Services: {
                share: 'Teilen FR',
            },
            SocialShare: {
                facebook: {
                    title: 'Facebook'
                },
                twitter: {
                    title: 'Twitter'
                },
                email: {
                    title: 'E-Mail',
                    subject: '',
                    text: ''
                },
            },
        }
    },
    en: {
        components: {
            Branding: {
                collection: "Collection"
            },
            Navigation: {
                search: {
                    searchQuery: "----",
                    searchTitle: "Title/object name",
                    searchYearFrom: "Earliest year (YYYY)",
                    searchYearTo: "Latest year (YYYY)",
                    searchPerson: "Designer/manufacturer",
                    searchMaterial: "Material/techniques",
                    searchInventoryNr: "Inventory number",
                    search: "Main"
                },
                extendedSearch: "Advanced search",
                ObjObjectTitleTxt: "Title/object name",
                objects: 'Objects',
                designers: 'Designer',
                producers: 'Manufacturer',
                objCategories: 'Object types',
                objAttributes: 'Attributes',
                objMaterials: 'Material',
                objUsage: 'Subjects',
                objHighlights: 'Highlights',
                objForKids: 'For kids',
                myCollection: "My collection",
                information: "Information",
            },
            SearchResults: {
                title: "Search results",
                objects: "Objects",
                designers: "Designer",
                producers: "Manufacturer",
            },
            Objects: {
                title: 'Objects'
            },
            ObjectDetail: {
                objectAttributes: 'Object details',
                objectObjectRelations: 'Objects',
                objectPersonRelation: 'Designer',
                ObjObjectNumberTxt: 'Object number',
                ObjObjectTitleTxt: 'Title/Object name',
                ObjObjectTitleSubTxt: '',
                ObjDesigner: 'Designer',
                ObjCategoryVoc: 'Object type',
                ObjDateGrp_DateFromTxt: 'Designed',
                ObjDateGrp_Notes2Clb: 'First production',
                ObjDateGrp_Notes3Clb: 'Later productions',
                ObjDateTxt: 'Dated',
                ObjMaterialTechniqueTxt: 'Material/Techniques',
                ObjDimension: 'Dimensions',
                ObjObjectNumberGrp_Part1Txt: 'Inventory number',
                ObjObjectRel: 'Objects',
                ObjPersonRel: 'Designer',
                ObjRelDesigners: 'Designer',
                ObjRelProducers: 'Manufacturer',
                ObjFloorplan: 'Object location',
            },
            ContentList: {
                Typ: "Object types",
                Funktion: "Attributes",
                Verwendung: "Subjects",
                Material: "Material",
            },
            Designers: {
                title: 'Designer'
            },
            Producers: {
                title: 'Manufacturer'
            },
            PersonDetail: {
                PerObjectsRel: 'Objects'
            },
            NoRecordsFound: {
                text: 'No results found.'
            },
            BackLink: {
                text: 'Back'
            },
            MyCollection: {
                title: 'My collection',
                buttonEdit: 'Edit',
                buttonDeleteAll: 'Remove all',
                objects: "Objects",
                designers: "Designer",
                producers: "Manufacturer",
            },
            Services: {
                share: 'Share',
            },
            SocialShare: {
                facebook: {
                    title: 'Facebook'
                },
                twitter: {
                    title: 'Twitter'
                },
                email: {
                    title: 'E-Mail',
                    subject: '',
                    text: ''
                },
            },
        }
    }
}


// WEBPACK FOOTER //
// ./config/locales.SD.js